import { formatDistanceToNow } from 'date-fns';
import { getTranslate } from '@/tolgee/server';
import { getLanguage } from '@/tolgee/language';
import { getDateLocale } from '@/lib/date-locale';

export const ProductPostedDate = async ({
  posted,
}: {
  posted: string | null;
}) => {
  const t = await getTranslate();
  const locale = await getLanguage();
  const dateLocale = getDateLocale(locale);

  const postedDate = formatDistanceToNow(
    new Date(posted || ''),
    { addSuffix: true, locale: dateLocale }
  );

  return (
    <p className='label-md !font-normal text-[#99A1AF]'>
      {t("product_posted_date.posted")} {postedDate}
    </p>
  );
};
